// Screen identities belong to editor selection, never to array position. Home
// remains the publication entry; hub content shares the registered section tree.
export function homeScreen(document) {
  return document.screens?.find((screen) => screen.route === '/home') ?? document.screens?.[0]
}

export function selectedScreen(document, selection = {}) {
  return document.screens?.find((screen) => screen.id === selection.screenId) ?? homeScreen(document)
}

export function screenContainingComponent(document, componentId) {
  return document.screens?.find((screen) => screen.components?.some((component) => component.id === componentId))
}

export function allScreenComponents(document) {
  return (document.screens ?? []).flatMap((screen) => screen.components ?? [])
}
